module.exports = __webpack_public_path__ + "img/Tahsildar.68cd1768.png";